export default "__VITE_ASSET__aa493baf__"